<template>
  <div>
    <material-card color="warning" icon="mdi-account-cash-outline" inline title="Invoice List">
      <v-row>
        <v-col cols="12" md="6" lg="4">
          <label class=" font-weight-medium body-2">Select Class</label>
          <v-autocomplete class="my-0 py-1" key="id" v-model="selectedClassID" placeholder="Select class" menu-props="auto" :items="classes" @change="getAllInfo()" item-text="name" item-value="id">
          </v-autocomplete>
        </v-col>
        <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width:350px;"
            @input="customSearch(search)"
          />
      </v-row>
      <v-card-component>
            <template>
              <v-col cols="12">
              <v-row justify="space-between">
                  <b>Total Royalty : {{totalClassRoyaltyAmount}}</b>
                  <b>Total Paid Royalty : {{totalClassPaidRoyaltyAmount}}</b>
                  <b>Total Due Royalty : {{totalClassDueRoyaltyAmount}}</b>
              </v-row>
              </v-col>
                <v-row>
                    <v-col cols="12" lg="12" sm="12">
                      <v-data-table
                        :headers="headers"
                        :items="searchFilterArray"
                        :items-per-page="10"
                        class="elevation-1"
                      >
                        <template v-slot:[`item.action`]="{ item }">
                          <v-btn class="px-2 ml-1 ma-1" :disabled="item.totalRoyaltyPaid === 0" min-width="0" small @click="getPaymentDetails(item)">
                            <v-icon color="black" small>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                </v-row>
            </template>
      </v-card-component>
    </material-card>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'

export default {
  name: 'PlanAssignInstallmentList',
  components: {
    MaterialCard,
    VCardComponent
  },
  props: ['referenceID'],
  data () {
    return {
      searchFilterArray: [],
      search: '',
      inProgress: false,
      gstType: 'IGST',
      isGST: false,
      isIGST: true,
      loadingComponent: null,
      totalAmountRoyalty: 0,
      totalClassRoyaltyAmount: 0,
      totalClassPaidRoyaltyAmount: 0,
      totalClassDueRoyaltyAmount: 0,
      totalAmountOrder: 0,
      totalAmountToPay: 0,
      classes: [],
      selectedClassID: '',
      infoEnquiriesCal: [],
      headers: [
        {
          text: 'Student Name',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: 'Enrollment Code', value: 'enrollmentCode' },
        { text: 'Class', value: 'className' },
        { text: 'Total Royalty', value: 'totalRoyalty' },
        { text: 'Royalty Paid', value: 'totalRoyaltyPaid' },
        { text: 'Royalty Due', value: 'totalRoyaltyDue' },
        { text: 'View Receipt', value: 'action' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    await this.onFranchiseeChange()
  },
  methods: {
    customSearch: function (value) {
      if (_.isEmpty(value)) {
        this.searchFilterArray = this.infoEnquiriesCal
      } else {
        this.searchFilterArray = _.filter(
          this.infoEnquiriesCal,
          item =>
            (item && item.enquiryCode && item.enquiryCode.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item && item.enrollmentCode && item.enrollmentCode.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item && item.studentFirstName.toLowerCase().search(value.toLowerCase()) >= 0)
        )
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
      if (this.franchiseeID) {
        await this.getClassList()
        if (this.selectedClassID) {
          await this.getAllInfo()
        }
      }
    },
    calculateTotalRoyalty (item) {
      let royalties = item.royalties
      let totalAmount = 0
      _.forEach(royalties, royalty => {
        let amount = Number(royalty.amountRoyalty) + Number(royalty.amountRoyaltyGSTPaid)
        totalAmount += Number(amount)
      })
      return this.toFixed(totalAmount)
    },
    calculateRoyaltyPaid (item) {
      let royalties = item.royalties
      let totalAmountPaid = 0
      _.forEach(royalties, royalty => {
        totalAmountPaid += Number(royalty.amountRoyaltyTotalPaid)
      })
      return this.toFixed(totalAmountPaid)
    },
    calculateRoyaltyDue (item) {
      let royalties = item.royalties
      let totalAmountDue = 0
      _.forEach(royalties, royalty => {
        totalAmountDue += Number(royalty.amountRoyaltyDue)
      })
      return this.toFixed(totalAmountDue)
    },
    calculateTotalClassRoyalty () {
      let royalties = this.infoEnquiriesCal
      this.totalClassRoyaltyAmount = 0
      _.forEach(royalties, royalty => {
        this.totalClassRoyaltyAmount += Number(royalty.totalRoyalty)
      })
      return this.toFixed(this.totalClassRoyaltyAmount)
    },
    calculateTotalPaidClassRoyalty () {
      let royalties = this.infoEnquiriesCal
      this.totalClassPaidRoyaltyAmount = 0
      _.forEach(royalties, royalty => {
        this.totalClassPaidRoyaltyAmount += Number(royalty.totalRoyaltyPaid)
      })
      return this.toFixed(this.totalClassPaidRoyaltyAmount)
    },
    calculateTotalDueClassRoyalty () {
      let royalties = this.infoEnquiriesCal
      this.totalClassDueRoyaltyAmount = 0
      _.forEach(royalties, royalty => {
        this.totalClassDueRoyaltyAmount += Number(royalty.totalRoyaltyDue)
      })
      return this.toFixed(this.totalClassDueRoyaltyAmount)
    },
    getAllInfo: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let response = await http.post(`${constants.API_URL}/api/students/royalty-kits`, { franchiseeID: this.franchiseeID, academicYearID: this.academicYearID, classID: this.selectedClassID, isAllData: true })
        this.infoEnquiriesCal = response.data.enquiriesCal
        this.infoEnquiriesCal.map(obj => {
          if (obj.royalties.length === 0) {
            let searchIndex = this.infoEnquiriesCal.indexOf(obj)
            this.infoEnquiriesCal.splice(searchIndex)
          }
        })
        this.infoEnquiriesCal.map(obj => {
          obj.totalRoyalty = this.calculateTotalRoyalty(obj)
          obj.totalRoyaltyPaid = this.calculateRoyaltyPaid(obj)
          obj.totalRoyaltyDue = this.calculateRoyaltyDue(obj)
          obj.name = obj.studentFirstName + ' ' + obj.studentLastName
          obj.className = obj.studentEnrollment.studentAdmissions[0].studentClass.name
        })
        this.totalAmountOrder = 0
        this.totalAmountRoyalty = 0
        this.gstType = response.data.gstType
        this.totalAmountRoyalty = response.data.orderTotal
        this.totalAmountOrder = response.data.royaltyTotal
        this.searchFilterArray = _.filter(this.infoEnquiriesCal, a => a.enrollmentCode)
        this.customSearch()
        this.calculateTotalClassRoyalty()
        this.calculateTotalPaidClassRoyalty()
        this.calculateTotalDueClassRoyalty()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    getPaymentDetails: async function (item) {
      try {
        if (item.studentEnrollment.studentAdmissions.length === 0) {
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: 'Student Admission not found!',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        this.$router.push({ name: 'student-royalty-details', params: { studentAdmissionID: item.studentEnrollment.studentAdmissions[0].id } })
      } finally {
        this.loadingComponent.close()
      }
    },
    addTwoNumber (num1, num2) {
      return this.toFixed(Number(num1) + Number(num2))
    },
    toFixed (number, length = 2) {
      return Number(Number(number).toFixed(length))
    },
    getClassList: async function () {
      try {
        this.isLoading = true

        let response = await http.get(`${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&isAllValue=true`)
        const data = response.data
        this.classes = data
        this.selectedClassID = this.classes[0].id
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}
td,
th {
  border: 1px solid;
}
.v-data-table.theme--light .v-data-table__wrapper {
  overflow-x: hidden !important;
}
</style>
